import React, { useEffect, useState } from "react";
import backArrow from "@assets/icons/arrow-left.svg";
import arrowDown from "@assets/icons/arrow-down.svg";
import fileUploadIcon from "@assets/icons/upload-icon.svg";
import fileIcon from "@assets/icons/file-upload.svg";
import topperIcon from "@assets/icons/topper-icon.svg";
import clockIcon from "@assets/icons/clock-icon.svg";
import chevronLeft from "@assets/icons/chevron-left.svg";
import chevronRight from "@assets/icons/chevron-right.svg";
import pdfIcon from "@assets/icons/pdf-icon.svg";
import { getExamSessionDetailsById } from "@services/adminDashboard";
import { subjectIDs } from "@constants/subject";
import StudentListUpload from "@modals/studentlistupload/StudentListUpload";
import UploadAnswerSheets from "@modals/uploadanswersheet/UploadAnswerSheets";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import styles from "./AnswerSheetUpload.module.css";
import { getExamSubmissionIdByExamId } from "@services/answersheetUpload";

function AnswerSheetUpload() {
  const [searchParams] = useSearchParams();
  const [examId, setExamId] = useState<string | null>(null);
  const [questionPaperId, setQuestionPaperId] = useState<string | null>(null);
  const [examData, setExamData] = useState<any | null>(null);
  const [studentFileDetails, setStudentFileDetails] = useState<any | null>(
    null
  );
  const [studentFileUrlData, setStudentFileUrlData] = useState<any | null>(
    null
  );
  const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false);
  const totalPages = 100;
  const navigate = useNavigate();
  const pageLocation = useLocation();
  const [currentSection, setCurrentSection] = useState(pageLocation.hash);
  const [currentPage, setCurrentPage] = useState(1);
  function formatDate(dateString: string) {
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  }

  const goToPage = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const goBack = () => {
    if (localStorage.getItem("studentFileDetails")) {
      localStorage.removeItem("studentFileDetails");
    }
    if (localStorage.getItem("studentFileUrlData")) {
      localStorage.removeItem("studentFileUrlData");
    }
    navigate(-1);
  };

  const fetchExamDetails = async (examId: string) => {
    const res = await getExamSessionDetailsById(examId);
    if (res) {
      setExamData(res);
    }
  };

  const goToSection = (hash: string) => {
    navigate(`${pageLocation.pathname}${hash}`, { replace: true });
  };

  const loadStudentFileDetails = () => {
    try {
      const storedData = localStorage.getItem("studentFileDetails");
      if (storedData) {
        const fileList = JSON.parse(storedData);
        setStudentFileDetails(fileList);
        console.log("Loaded student file details from localStorage:", fileList);
      } else {
        setStudentFileDetails(null);
        console.log("No student file details found in localStorage");
      }
    } catch (error) {
      console.error(
        "Error parsing studentFileDetails from localStorage:",
        error
      );
      setStudentFileDetails(null);
    }
    try {
      const storedData = localStorage.getItem("studentFileUrlData");
      if (storedData) {
        const fileListUrls = JSON.parse(storedData);
        setStudentFileUrlData(fileListUrls);
        console.log(
          "Loaded student file details from localStorage:",
          studentFileUrlData
        );
      } else {
        setStudentFileDetails(null);
        console.log("No student file details found in localStorage");
      }
    } catch (error) {
      console.error(
        "Error parsing studentFileDetails from localStorage:",
        error
      );
      setStudentFileDetails(null);
    }
  };

  const fetchStudenSubmissionDetails = async (examId: string | null) => {
    const res = await getExamSubmissionIdByExamId(examId, "", 10);
    if (res) {
      console.log("ressss: ", res);
    }
  };

  useEffect(() => {
    setCurrentSection(pageLocation.hash);
  }, [pageLocation.hash]);

  useEffect(() => {
    const initializeData = async () => {
      loadStudentFileDetails();
      const exam_id = searchParams.get("exam_id");
      const question_paper_id = searchParams.get("question_paper_id");

      if (exam_id) {
        await fetchExamDetails(exam_id);
        await fetchStudenSubmissionDetails(exam_id);
        setExamId(exam_id);
      }
      if (question_paper_id) {
        setQuestionPaperId(question_paper_id);
      }
      setIsDataLoaded(true);
    };

    initializeData();
  }, [searchParams]);

  useEffect(() => {
    const handleStorageChange = () => {
      loadStudentFileDetails();
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("focus", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("focus", handleStorageChange);
    };
  }, []);

  const refreshStudentData = () => {
    loadStudentFileDetails();
  };

  useEffect(() => {
    (window as any).refreshStudentData = refreshStudentData;
    return () => {
      delete (window as any).refreshStudentData;
    };
  }, []);

  if (!isDataLoaded) {
    return (
      <div className={styles.answerUploadContainer}>
        <div className={styles.backButtonContainer}>
          <button className={styles.backButton} onClick={goBack}>
            <img src={backArrow} alt="Back" className={styles.arrowDown} /> Back
          </button>
        </div>
        <div className={styles.testDetails}>
          <h1 className={styles.testTitle}>Loading...</h1>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.answerUploadContainer}>
      <div className={styles.backButtonContainer}>
        <button className={styles.backButton} onClick={goBack}>
          <img src={backArrow} alt="Back" className={styles.arrowDown} /> Back
        </button>
        {studentFileDetails?.length > 0 && (
          <button
            className={styles.uploadAnswerButton}
            onClick={() => goToSection("#section2")}
          >
            <img src={fileUploadIcon} alt="Upload" /> Upload answer sheets
            <img
              src={arrowDown}
              alt="Arrow Down"
              className={styles.arrowDown}
            />
          </button>
        )}
      </div>
      <div className={styles.testDetails}>
        <h1 className={styles.testTitle}>{examData?.name}</h1>
        {examData?.exam_date && (
          <div className={styles.testDate}>
            {formatDate(examData?.exam_date)}
          </div>
        )}
        <div className={styles.testInfo}>
          {examData?.grade_ids?.length > 0 && (
            <>
              <div className={styles.testInfoItem}>
                <img src={topperIcon} alt="Topper" />
                <span>{`Grade ${examData?.grade_ids[0]}`}</span>
              </div>
              <div className={styles.testInfoItem}>
                <span>|</span>
              </div>
            </>
          )}
          {examData?.duration && (
            <>
              <div className={styles.testInfoItem}>
                <img src={clockIcon} alt="Clock" />
                <span>{`${examData?.duration} mins`}</span>
              </div>
              <div className={styles.testInfoItem}>
                <span>|</span>
              </div>
            </>
          )}
          {examData?.subject_ids?.length > 0 && (
            <>
              <div className={styles.testInfoItem}>
                <span>{subjectIDs[examData?.subject_ids[0]]}</span>
              </div>
              <div className={styles.testInfoItem}>
                <span>|</span>
              </div>
            </>
          )}
          {examData?.totalMarks && (
            <>
              <div className={styles.testInfoItem}>
                <span>360 Marks</span>
              </div>
              <div className={styles.testInfoItem}>
                <span>|</span>
              </div>
            </>
          )}
        </div>
        <div className={styles.studentsInfo}>
          <div>
            {studentFileDetails?.length > 0 && (
              <h2>{`Students (${studentFileDetails?.length})`}</h2>
            )}
          </div>
          <button
            className={styles.uploadAnswerButton}
            onClick={() => goToSection("#section1")}
          >
            UPLOAD STUDENTS DETAILS
          </button>
        </div>
        {/* {studentFileUrlData?.length > 0 &&
                    <div className={styles.testListTitle}>
                        <div className={styles.testListTitleActions}>
                            <div className={styles.testListPageCountSelect}>
                                <select>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                                <img src={arrowDown} alt="Arrow Down Icon" className={styles.arrowDownIcon} />
                            </div>
                            <div className={styles.testListPagination}>
                                <button
                                    onClick={() => goToPage(currentPage - 1)}
                                    disabled={currentPage === 1}
                                    className={styles.testListPaginationButton}
                                >
                                    <img src={chevronLeft} alt="Previous" />
                                </button>
                                <span
                                    onClick={() => goToPage(1)}
                                    className={`${styles.testListPaginationPageNumber} ${currentPage === 1 ? styles.active : ""}`}
                                >
                                    1
                                </span>

                                {currentPage > 2 && currentPage < totalPages - 1 && <span className={styles.testListPaginationEllipsis}>...</span>}

                                {currentPage !== 1 && currentPage !== totalPages && (
                                    <span className={`${styles.testListPaginationPageNumber} ${styles.active}`}>{currentPage}</span>
                                )}
                                {currentPage + 1 < totalPages && (
                                    <span className={`${styles.testListPaginationPageNumber}`} onClick={() => goToPage(currentPage + 1)} style={{ cursor: "pointer" }}>
                                        {currentPage + 1}
                                    </span>
                                )}

                                {currentPage < totalPages - 2 && <span className={styles.testListPaginationEllipsis}>...</span>}

                                <span
                                    className={`${styles.testListPaginationPageNumber} ${currentPage === totalPages ? styles.active : ""}`}
                                    onClick={() => goToPage(totalPages)}
                                >
                                    {totalPages}
                                </span>
                                <button
                                    onClick={() => goToPage(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                    className={styles.testListPaginationButton}
                                >
                                    <img src={chevronRight} alt="Next" />
                                </button>
                            </div>
                        </div>
                    </div>} */}
      </div>

      {studentFileUrlData?.length > 0 ? (
        <div className={styles.testListTable}>
          <table>
            <thead>
              <tr>
                <th>
                  <div className={styles.tableColumn}>
                    <span>Admission ID</span>
                    <div className={styles.columnSort}>
                      <img
                        src={arrowDown}
                        alt="Sort"
                        className={styles.arrowUp}
                      />
                      <img src={arrowDown} alt="Sort" />
                    </div>
                  </div>
                </th>
                <th>
                  <div className={styles.tableColumn}>
                    <span>PDF File Name</span>
                    <div className={styles.columnSort}>
                      <img
                        src={arrowDown}
                        alt="Sort"
                        className={styles.arrowUp}
                      />
                      <img src={arrowDown} alt="Sort" />
                    </div>
                  </div>
                </th>
                {/* <th><div className={styles.tableColumn}><span>PDF Preview</span><div className={styles.columnSort}><img src={arrowDown} alt="Sort" className={styles.arrowUp} /><img src={arrowDown} alt="Sort" /></div></div></th> */}
                <th>
                  <div className={styles.tableColumn}>
                    <span>Remarks</span>
                    <div className={styles.columnSort}>
                      <img
                        src={arrowDown}
                        alt="Sort"
                        className={styles.arrowUp}
                      />
                      <img src={arrowDown} alt="Sort" />
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {studentFileUrlData?.map((student: any) => (
                <tr key={student.student_identifier}>
                  <td>{student.student_identifier}</td>
                  <td>{student.original_filename}</td>
                  {/* <td>
                                        {student.uploadStatus == "success" && student.file
                                            ? <a href={student.file} target="_blank" rel="noopener noreferrer" className={styles.pdfLink}><img src={pdfIcon} alt="View pdf" />View pdf</a>
                                            : null}
                                        {student.uploadStatus == "failed" && <span className={styles.errorMessage}>File not Uploaded</span>}
                                        {student.uploadStatus == "pending" && <span className={styles.pendingMessage}>File Upload Pending</span>}
                                    </td> */}
                  <td>
                    {student.uploadStatus == "failed" ? (
                      <form className={styles.reuploadForm}>
                        <input
                          type="file"
                          id={`studentFileUpload_${student.student_identifier}`}
                        />
                        <label
                          htmlFor={`studentFileUpload_${student.student_identifier}`}
                        >
                          Re-upload
                        </label>
                      </form>
                    ) : (
                      "File uploaded"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className={styles.fileUploadContainer}>
          <div className={styles.fileUpload}>
            <button
              className={styles.fileLabel}
              onClick={() => goToSection("#section1")}
            >
              UPLOAD STUDENTS DETAILS
              <img src={fileIcon} alt="Upload" />
            </button>
            <div className={styles.fileInfo}>
              <p>
                Please{" "}
                <a href="src/assets/csvs/studentListUploadTemplate.csv" download>
                  click here
                </a>{" "}
                to download a template for .csv file format
              </p>
              <p>File size must be less than 20MB</p>
              <p>Supported format for upload- .csv</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default AnswerSheetUpload;